import Swiper from 'swiper/bundle';

(function () {
    const slider = document.querySelector('[data-review-slider]');

    if (slider) {
        const slidesCount = slider.querySelectorAll('.swiper-slide').length;
        const initialSlide = Math.floor(slidesCount / 2);

        new Swiper(slider, {
            spaceBetween: 24,
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    allowTouchMove: true,
                    centeredSlides: false,
                    initialSlide: 0,
                    spaceBetween: 15,
                },
                767: {
                    slidesPerView: 2,
                },
                991: {
                    slidesPerView: 3,
                },
                1199: {
                    allowTouchMove: false,
                    centeredSlides: true,
                    initialSlide: initialSlide,
                }
            },
            on: {
                init: function () {
                    const counts = (elem, type) => {
                        let matched = [];

                        if (type === 'next') {
                            while (elem = elem.nextSibling) if (elem.nodeType === 1) matched.push(elem);
                        } else {
                            while (elem = elem.previousSibling) if (elem.nodeType === 1) matched.push(elem);
                        }

                        return matched.length;
                    }

                    if (window.innerWidth >= 1200) {
                        const nextBtn = document.querySelector('.swiper-button-next')
                        const prevBtn = document.querySelector('.swiper-button-prev')

                        if (nextBtn) {
                            nextBtn.addEventListener('click', (btn) => {
                                const activeSlide = slider.querySelector('.swiper-slide-active')

                                if (counts(activeSlide, 'next') <= 1) {
                                    btn.target.classList.add('swiper-button-disabled')
                                }

                                prevBtn.classList.remove('swiper-button-disabled')
                            })
                        }

                        if (prevBtn) {
                            prevBtn.addEventListener('click', (btn) => {
                                const activeSlide = slider.querySelector('.swiper-slide-active')

                                if (counts(activeSlide, 'prev') <= 1) {
                                    btn.target.classList.add('swiper-button-disabled')
                                }

                                nextBtn.classList.remove('swiper-button-disabled')
                            })
                        }
                    }
                },
            },
        });
    }
})();
